// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"BizCreatorList_componentStyle__ovUtb","listItem":"BizCreatorList_listItem__KnLvP"};